// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pmGJ","list":"styles_list__1Q1N8"};